import React, { Component } from 'react';

import { handleStart, handleMove, handleEnd } from './event-handlers';

/**
 * handle resizing
 */
export default class DragResizer extends Component {
  constructor(props) {
    super(props);

    this.touchState = {};
    this.swipeRef = React.createRef();

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleWindowMouseMove = this.handleWindowMouseMove.bind(this);
    this.handleWindowMouseUp = this.handleWindowMouseUp.bind(this);
  }

  handleMouseDown(e) {
    e.persist();
    handleStart(this.props, this.touchState, e, this.swipeRef);

    window.addEventListener('mousemove', this.handleWindowMouseMove);
    window.addEventListener('mouseup', this.handleWindowMouseUp);
  }

  handleWindowMouseMove(e) {
    handleMove(this.props, this.touchState, e, this.swipeRef.current);
  }

  handleWindowMouseUp() {
    window.removeEventListener('mousemove', this.handleWindowMouseMove);
    window.removeEventListener('mouseup', this.handleWindowMouseUp);

    handleEnd(this.props, this.touchState);
  }

  render() {
    return (
      <div
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        ref={this.swipeRef}
        onMouseDown={this.handleMouseDown}
        role="presentation"
        draggable
      />
    );
  }
}
